module.exports = __webpack_public_path__ + "img/main.67615c68.jpeg";